
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        }
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("7BEQW"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("h0x7a"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("bxHwe"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("6Sfbk"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("3RQLA"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("dMz0s"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("7PDFv"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("3ZfBa"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("knbBH"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("4Mq4C"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("aCH1P"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("a3THr"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("7BEQW", function(module, exports) {

let $589bada61e52c85a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $589bada61e52c85a$var$load("2YffH"),
    $589bada61e52c85a$var$load("8Kivm"),
    $589bada61e52c85a$var$load("1V9QO"),
    $589bada61e52c85a$var$load("j03h9"),
    $589bada61e52c85a$var$load("iQ0Jm"),
    $589bada61e52c85a$var$load("ev7SX"),
    $589bada61e52c85a$var$load("eiooB"),
    $589bada61e52c85a$var$load("iLyOq"),
    $589bada61e52c85a$var$load("h4Nf7"),
    $589bada61e52c85a$var$load("7f9Fz"),
    $589bada61e52c85a$var$load("8YSo7"),
    $589bada61e52c85a$var$load("lYvov"),
    $589bada61e52c85a$var$load("k8XPW"),
    $589bada61e52c85a$var$load("fWCRm"),
    $589bada61e52c85a$var$load("g9CVe"),
    $589bada61e52c85a$var$load("aeEUI"),
    $589bada61e52c85a$var$load("hRUX7"),
    $589bada61e52c85a$var$load("g4oYs"),
    $589bada61e52c85a$var$load("6wr18"),
    $589bada61e52c85a$var$load("kjZZD"),
    $589bada61e52c85a$var$load("3ySTn"),
    $589bada61e52c85a$var$load("c2rHL"),
    $589bada61e52c85a$var$load("awqCy"),
    $589bada61e52c85a$var$load("kHOMt"),
    $589bada61e52c85a$var$load("hhss7"),
    $589bada61e52c85a$var$load("6kZfp"),
    $589bada61e52c85a$var$load("2UbDA"),
    $589bada61e52c85a$var$load("nbjnv"),
    $589bada61e52c85a$var$load("Wowvf"),
    $589bada61e52c85a$var$load("ffEVr"),
    $589bada61e52c85a$var$load("jlSv2"),
    $589bada61e52c85a$var$load("1UUrt"),
    $589bada61e52c85a$var$load("jSdjl"),
    $589bada61e52c85a$var$load("l2EUC"),
    $589bada61e52c85a$var$load("kWZnd"),
    $589bada61e52c85a$var$load("92LGf"),
    $589bada61e52c85a$var$load("jk2zg"),
    $589bada61e52c85a$var$load("zjNVa"),
    $589bada61e52c85a$var$load("9IeAj"),
    $589bada61e52c85a$var$load("kUbUu"),
    $589bada61e52c85a$var$load("2PePB"),
    $589bada61e52c85a$var$load("1W4KB"),
    $589bada61e52c85a$var$load("lnKog"),
    $589bada61e52c85a$var$load("9ftJe"),
    $589bada61e52c85a$var$load("h3ABO"),
    $589bada61e52c85a$var$load("kC80R"),
    $589bada61e52c85a$var$load("7EorR"),
    $589bada61e52c85a$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("h0x7a", function(module, exports) {

let $c61c1f9af807684c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c61c1f9af807684c$var$load("2YffH"),
    $c61c1f9af807684c$var$load("8Kivm"),
    $c61c1f9af807684c$var$load("1V9QO"),
    $c61c1f9af807684c$var$load("j03h9"),
    $c61c1f9af807684c$var$load("iQ0Jm"),
    $c61c1f9af807684c$var$load("ev7SX"),
    $c61c1f9af807684c$var$load("eiooB"),
    $c61c1f9af807684c$var$load("iLyOq"),
    $c61c1f9af807684c$var$load("h4Nf7"),
    $c61c1f9af807684c$var$load("7f9Fz"),
    $c61c1f9af807684c$var$load("8YSo7"),
    $c61c1f9af807684c$var$load("lYvov"),
    $c61c1f9af807684c$var$load("k8XPW"),
    $c61c1f9af807684c$var$load("fWCRm"),
    $c61c1f9af807684c$var$load("g9CVe"),
    $c61c1f9af807684c$var$load("aeEUI"),
    $c61c1f9af807684c$var$load("hRUX7"),
    $c61c1f9af807684c$var$load("g4oYs"),
    $c61c1f9af807684c$var$load("6wr18"),
    $c61c1f9af807684c$var$load("kjZZD"),
    $c61c1f9af807684c$var$load("3ySTn"),
    $c61c1f9af807684c$var$load("c2rHL"),
    $c61c1f9af807684c$var$load("awqCy"),
    $c61c1f9af807684c$var$load("kHOMt"),
    $c61c1f9af807684c$var$load("hhss7"),
    $c61c1f9af807684c$var$load("6kZfp"),
    $c61c1f9af807684c$var$load("2UbDA"),
    $c61c1f9af807684c$var$load("nbjnv"),
    $c61c1f9af807684c$var$load("Wowvf"),
    $c61c1f9af807684c$var$load("ffEVr"),
    $c61c1f9af807684c$var$load("jlSv2"),
    $c61c1f9af807684c$var$load("1UUrt"),
    $c61c1f9af807684c$var$load("jSdjl"),
    $c61c1f9af807684c$var$load("l2EUC"),
    $c61c1f9af807684c$var$load("kWZnd"),
    $c61c1f9af807684c$var$load("92LGf"),
    $c61c1f9af807684c$var$load("jk2zg"),
    $c61c1f9af807684c$var$load("zjNVa"),
    $c61c1f9af807684c$var$load("9IeAj"),
    $c61c1f9af807684c$var$load("kUbUu"),
    $c61c1f9af807684c$var$load("2PePB"),
    $c61c1f9af807684c$var$load("1W4KB"),
    $c61c1f9af807684c$var$load("lnKog"),
    $c61c1f9af807684c$var$load("9ftJe"),
    $c61c1f9af807684c$var$load("h3ABO"),
    $c61c1f9af807684c$var$load("kC80R"),
    $c61c1f9af807684c$var$load("7EorR"),
    $c61c1f9af807684c$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("bxHwe", function(module, exports) {

let $867488bc931f0911$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $867488bc931f0911$var$load("2YffH"),
    $867488bc931f0911$var$load("8Kivm"),
    $867488bc931f0911$var$load("1V9QO"),
    $867488bc931f0911$var$load("j03h9"),
    $867488bc931f0911$var$load("iQ0Jm"),
    $867488bc931f0911$var$load("ev7SX"),
    $867488bc931f0911$var$load("eiooB"),
    $867488bc931f0911$var$load("iLyOq"),
    $867488bc931f0911$var$load("h4Nf7"),
    $867488bc931f0911$var$load("7f9Fz"),
    $867488bc931f0911$var$load("8YSo7"),
    $867488bc931f0911$var$load("lYvov"),
    $867488bc931f0911$var$load("k8XPW"),
    $867488bc931f0911$var$load("fWCRm"),
    $867488bc931f0911$var$load("g9CVe"),
    $867488bc931f0911$var$load("aeEUI"),
    $867488bc931f0911$var$load("hRUX7"),
    $867488bc931f0911$var$load("g4oYs"),
    $867488bc931f0911$var$load("6wr18"),
    $867488bc931f0911$var$load("kjZZD"),
    $867488bc931f0911$var$load("3ySTn"),
    $867488bc931f0911$var$load("c2rHL"),
    $867488bc931f0911$var$load("awqCy"),
    $867488bc931f0911$var$load("kHOMt"),
    $867488bc931f0911$var$load("hhss7"),
    $867488bc931f0911$var$load("6kZfp"),
    $867488bc931f0911$var$load("2UbDA"),
    $867488bc931f0911$var$load("nbjnv"),
    $867488bc931f0911$var$load("Wowvf"),
    $867488bc931f0911$var$load("ffEVr"),
    $867488bc931f0911$var$load("jlSv2"),
    $867488bc931f0911$var$load("1UUrt"),
    $867488bc931f0911$var$load("jSdjl"),
    $867488bc931f0911$var$load("l2EUC"),
    $867488bc931f0911$var$load("kWZnd"),
    $867488bc931f0911$var$load("92LGf"),
    $867488bc931f0911$var$load("jk2zg"),
    $867488bc931f0911$var$load("zjNVa"),
    $867488bc931f0911$var$load("9IeAj"),
    $867488bc931f0911$var$load("kUbUu"),
    $867488bc931f0911$var$load("2PePB"),
    $867488bc931f0911$var$load("1W4KB"),
    $867488bc931f0911$var$load("lnKog"),
    $867488bc931f0911$var$load("9ftJe"),
    $867488bc931f0911$var$load("h3ABO"),
    $867488bc931f0911$var$load("kC80R"),
    $867488bc931f0911$var$load("7EorR"),
    $867488bc931f0911$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("6Sfbk", function(module, exports) {

let $50138ffd37309892$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $50138ffd37309892$var$load("k8XPW"),
    $50138ffd37309892$var$load("fWCRm"),
    $50138ffd37309892$var$load("2YffH"),
    $50138ffd37309892$var$load("2PePB"),
    $50138ffd37309892$var$load("1V9QO"),
    $50138ffd37309892$var$load("j03h9"),
    $50138ffd37309892$var$load("eiooB"),
    $50138ffd37309892$var$load("iLyOq"),
    $50138ffd37309892$var$load("h4Nf7"),
    $50138ffd37309892$var$load("7f9Fz"),
    $50138ffd37309892$var$load("8YSo7"),
    $50138ffd37309892$var$load("lYvov"),
    $50138ffd37309892$var$load("g9CVe"),
    $50138ffd37309892$var$load("aeEUI"),
    $50138ffd37309892$var$load("hRUX7"),
    $50138ffd37309892$var$load("g4oYs"),
    $50138ffd37309892$var$load("6wr18"),
    $50138ffd37309892$var$load("kjZZD"),
    $50138ffd37309892$var$load("3ySTn"),
    $50138ffd37309892$var$load("c2rHL"),
    $50138ffd37309892$var$load("awqCy"),
    $50138ffd37309892$var$load("kHOMt"),
    $50138ffd37309892$var$load("hhss7"),
    $50138ffd37309892$var$load("6kZfp"),
    $50138ffd37309892$var$load("2UbDA"),
    $50138ffd37309892$var$load("nbjnv"),
    $50138ffd37309892$var$load("Wowvf"),
    $50138ffd37309892$var$load("ffEVr"),
    $50138ffd37309892$var$load("jlSv2"),
    $50138ffd37309892$var$load("1UUrt"),
    $50138ffd37309892$var$load("jSdjl"),
    $50138ffd37309892$var$load("l2EUC"),
    $50138ffd37309892$var$load("kWZnd"),
    $50138ffd37309892$var$load("92LGf"),
    $50138ffd37309892$var$load("jk2zg"),
    $50138ffd37309892$var$load("zjNVa"),
    $50138ffd37309892$var$load("9IeAj"),
    $50138ffd37309892$var$load("1W4KB"),
    $50138ffd37309892$var$load("kUbUu"),
    $50138ffd37309892$var$load("9ftJe"),
    $50138ffd37309892$var$load("h3ABO"),
    $50138ffd37309892$var$load("kC80R"),
    $50138ffd37309892$var$load("7EorR"),
    $50138ffd37309892$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("3RQLA", function(module, exports) {

let $2d0f40ae4c5b6181$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2d0f40ae4c5b6181$var$load("k8XPW"),
    $2d0f40ae4c5b6181$var$load("fWCRm"),
    $2d0f40ae4c5b6181$var$load("2YffH"),
    $2d0f40ae4c5b6181$var$load("2PePB"),
    $2d0f40ae4c5b6181$var$load("1V9QO"),
    $2d0f40ae4c5b6181$var$load("j03h9"),
    $2d0f40ae4c5b6181$var$load("eiooB"),
    $2d0f40ae4c5b6181$var$load("iLyOq"),
    $2d0f40ae4c5b6181$var$load("h4Nf7"),
    $2d0f40ae4c5b6181$var$load("7f9Fz"),
    $2d0f40ae4c5b6181$var$load("8YSo7"),
    $2d0f40ae4c5b6181$var$load("lYvov"),
    $2d0f40ae4c5b6181$var$load("g9CVe"),
    $2d0f40ae4c5b6181$var$load("aeEUI"),
    $2d0f40ae4c5b6181$var$load("hRUX7"),
    $2d0f40ae4c5b6181$var$load("g4oYs"),
    $2d0f40ae4c5b6181$var$load("6wr18"),
    $2d0f40ae4c5b6181$var$load("kjZZD"),
    $2d0f40ae4c5b6181$var$load("3ySTn"),
    $2d0f40ae4c5b6181$var$load("c2rHL"),
    $2d0f40ae4c5b6181$var$load("awqCy"),
    $2d0f40ae4c5b6181$var$load("kHOMt"),
    $2d0f40ae4c5b6181$var$load("hhss7"),
    $2d0f40ae4c5b6181$var$load("6kZfp"),
    $2d0f40ae4c5b6181$var$load("2UbDA"),
    $2d0f40ae4c5b6181$var$load("nbjnv"),
    $2d0f40ae4c5b6181$var$load("Wowvf"),
    $2d0f40ae4c5b6181$var$load("ffEVr"),
    $2d0f40ae4c5b6181$var$load("jlSv2"),
    $2d0f40ae4c5b6181$var$load("1UUrt"),
    $2d0f40ae4c5b6181$var$load("jSdjl"),
    $2d0f40ae4c5b6181$var$load("l2EUC"),
    $2d0f40ae4c5b6181$var$load("kWZnd"),
    $2d0f40ae4c5b6181$var$load("92LGf"),
    $2d0f40ae4c5b6181$var$load("jk2zg"),
    $2d0f40ae4c5b6181$var$load("zjNVa"),
    $2d0f40ae4c5b6181$var$load("9IeAj"),
    $2d0f40ae4c5b6181$var$load("1W4KB"),
    $2d0f40ae4c5b6181$var$load("kUbUu"),
    $2d0f40ae4c5b6181$var$load("9ftJe"),
    $2d0f40ae4c5b6181$var$load("h3ABO"),
    $2d0f40ae4c5b6181$var$load("kC80R"),
    $2d0f40ae4c5b6181$var$load("7EorR"),
    $2d0f40ae4c5b6181$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("dMz0s", function(module, exports) {

let $a08ae9932574a16d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a08ae9932574a16d$var$load("k8XPW"),
    $a08ae9932574a16d$var$load("fWCRm"),
    $a08ae9932574a16d$var$load("2YffH"),
    $a08ae9932574a16d$var$load("2PePB"),
    $a08ae9932574a16d$var$load("1V9QO"),
    $a08ae9932574a16d$var$load("j03h9"),
    $a08ae9932574a16d$var$load("eiooB"),
    $a08ae9932574a16d$var$load("iLyOq"),
    $a08ae9932574a16d$var$load("h4Nf7"),
    $a08ae9932574a16d$var$load("7f9Fz"),
    $a08ae9932574a16d$var$load("8YSo7"),
    $a08ae9932574a16d$var$load("lYvov"),
    $a08ae9932574a16d$var$load("g9CVe"),
    $a08ae9932574a16d$var$load("aeEUI"),
    $a08ae9932574a16d$var$load("hRUX7"),
    $a08ae9932574a16d$var$load("g4oYs"),
    $a08ae9932574a16d$var$load("6wr18"),
    $a08ae9932574a16d$var$load("kjZZD"),
    $a08ae9932574a16d$var$load("3ySTn"),
    $a08ae9932574a16d$var$load("c2rHL"),
    $a08ae9932574a16d$var$load("awqCy"),
    $a08ae9932574a16d$var$load("kHOMt"),
    $a08ae9932574a16d$var$load("hhss7"),
    $a08ae9932574a16d$var$load("6kZfp"),
    $a08ae9932574a16d$var$load("2UbDA"),
    $a08ae9932574a16d$var$load("nbjnv"),
    $a08ae9932574a16d$var$load("Wowvf"),
    $a08ae9932574a16d$var$load("ffEVr"),
    $a08ae9932574a16d$var$load("jlSv2"),
    $a08ae9932574a16d$var$load("1UUrt"),
    $a08ae9932574a16d$var$load("jSdjl"),
    $a08ae9932574a16d$var$load("l2EUC"),
    $a08ae9932574a16d$var$load("kWZnd"),
    $a08ae9932574a16d$var$load("92LGf"),
    $a08ae9932574a16d$var$load("jk2zg"),
    $a08ae9932574a16d$var$load("zjNVa"),
    $a08ae9932574a16d$var$load("9IeAj"),
    $a08ae9932574a16d$var$load("1W4KB"),
    $a08ae9932574a16d$var$load("kUbUu"),
    $a08ae9932574a16d$var$load("9ftJe"),
    $a08ae9932574a16d$var$load("h3ABO"),
    $a08ae9932574a16d$var$load("kC80R"),
    $a08ae9932574a16d$var$load("7EorR"),
    $a08ae9932574a16d$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("7PDFv", function(module, exports) {

let $5b3c112af043786b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b3c112af043786b$var$load("k8XPW"),
    $5b3c112af043786b$var$load("fWCRm"),
    $5b3c112af043786b$var$load("2YffH"),
    $5b3c112af043786b$var$load("1V9QO"),
    $5b3c112af043786b$var$load("j03h9"),
    $5b3c112af043786b$var$load("eiooB"),
    $5b3c112af043786b$var$load("iLyOq"),
    $5b3c112af043786b$var$load("h4Nf7"),
    $5b3c112af043786b$var$load("7f9Fz"),
    $5b3c112af043786b$var$load("8YSo7"),
    $5b3c112af043786b$var$load("lYvov"),
    $5b3c112af043786b$var$load("g9CVe"),
    $5b3c112af043786b$var$load("aeEUI"),
    $5b3c112af043786b$var$load("hRUX7"),
    $5b3c112af043786b$var$load("g4oYs"),
    $5b3c112af043786b$var$load("6wr18"),
    $5b3c112af043786b$var$load("kjZZD"),
    $5b3c112af043786b$var$load("3ySTn"),
    $5b3c112af043786b$var$load("c2rHL"),
    $5b3c112af043786b$var$load("awqCy"),
    $5b3c112af043786b$var$load("kHOMt"),
    $5b3c112af043786b$var$load("hhss7"),
    $5b3c112af043786b$var$load("6kZfp"),
    $5b3c112af043786b$var$load("2UbDA"),
    $5b3c112af043786b$var$load("nbjnv"),
    $5b3c112af043786b$var$load("Wowvf"),
    $5b3c112af043786b$var$load("ffEVr"),
    $5b3c112af043786b$var$load("jlSv2"),
    $5b3c112af043786b$var$load("1UUrt"),
    $5b3c112af043786b$var$load("jSdjl"),
    $5b3c112af043786b$var$load("l2EUC"),
    $5b3c112af043786b$var$load("kWZnd"),
    $5b3c112af043786b$var$load("92LGf"),
    $5b3c112af043786b$var$load("jk2zg"),
    $5b3c112af043786b$var$load("zjNVa"),
    $5b3c112af043786b$var$load("9IeAj"),
    $5b3c112af043786b$var$load("kUbUu"),
    $5b3c112af043786b$var$load("2PePB"),
    $5b3c112af043786b$var$load("1W4KB"),
    $5b3c112af043786b$var$load("lnKog"),
    $5b3c112af043786b$var$load("9ftJe"),
    $5b3c112af043786b$var$load("h3ABO"),
    $5b3c112af043786b$var$load("kC80R"),
    $5b3c112af043786b$var$load("7EorR"),
    $5b3c112af043786b$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("3ZfBa", function(module, exports) {

let $2e732b215dc0bd7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e732b215dc0bd7b$var$load("2YffH"),
    $2e732b215dc0bd7b$var$load("1V9QO"),
    $2e732b215dc0bd7b$var$load("j03h9"),
    $2e732b215dc0bd7b$var$load("ev7SX"),
    $2e732b215dc0bd7b$var$load("eiooB"),
    $2e732b215dc0bd7b$var$load("iLyOq"),
    $2e732b215dc0bd7b$var$load("h4Nf7"),
    $2e732b215dc0bd7b$var$load("7f9Fz"),
    $2e732b215dc0bd7b$var$load("8YSo7"),
    $2e732b215dc0bd7b$var$load("lYvov"),
    $2e732b215dc0bd7b$var$load("k8XPW"),
    $2e732b215dc0bd7b$var$load("fWCRm"),
    $2e732b215dc0bd7b$var$load("g9CVe"),
    $2e732b215dc0bd7b$var$load("aeEUI"),
    $2e732b215dc0bd7b$var$load("hRUX7"),
    $2e732b215dc0bd7b$var$load("g4oYs"),
    $2e732b215dc0bd7b$var$load("6wr18"),
    $2e732b215dc0bd7b$var$load("kjZZD"),
    $2e732b215dc0bd7b$var$load("3ySTn"),
    $2e732b215dc0bd7b$var$load("c2rHL"),
    $2e732b215dc0bd7b$var$load("dTsOE"),
    $2e732b215dc0bd7b$var$load("awqCy"),
    $2e732b215dc0bd7b$var$load("kHOMt"),
    $2e732b215dc0bd7b$var$load("hhss7"),
    $2e732b215dc0bd7b$var$load("6kZfp"),
    $2e732b215dc0bd7b$var$load("2UbDA"),
    $2e732b215dc0bd7b$var$load("nbjnv"),
    $2e732b215dc0bd7b$var$load("Wowvf"),
    $2e732b215dc0bd7b$var$load("ffEVr"),
    $2e732b215dc0bd7b$var$load("jlSv2"),
    $2e732b215dc0bd7b$var$load("1UUrt"),
    $2e732b215dc0bd7b$var$load("jSdjl"),
    $2e732b215dc0bd7b$var$load("l2EUC"),
    $2e732b215dc0bd7b$var$load("kWZnd"),
    $2e732b215dc0bd7b$var$load("92LGf"),
    $2e732b215dc0bd7b$var$load("jk2zg"),
    $2e732b215dc0bd7b$var$load("zjNVa"),
    $2e732b215dc0bd7b$var$load("9IeAj"),
    $2e732b215dc0bd7b$var$load("kUbUu"),
    $2e732b215dc0bd7b$var$load("2PePB"),
    $2e732b215dc0bd7b$var$load("1W4KB"),
    $2e732b215dc0bd7b$var$load("lnKog"),
    $2e732b215dc0bd7b$var$load("9ftJe"),
    $2e732b215dc0bd7b$var$load("h3ABO"),
    $2e732b215dc0bd7b$var$load("kC80R"),
    $2e732b215dc0bd7b$var$load("7EorR"),
    $2e732b215dc0bd7b$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("knbBH", function(module, exports) {

let $ed4ef589a938ab7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ed4ef589a938ab7a$var$load("2YffH"),
    $ed4ef589a938ab7a$var$load("1V9QO"),
    $ed4ef589a938ab7a$var$load("j03h9"),
    $ed4ef589a938ab7a$var$load("ev7SX"),
    $ed4ef589a938ab7a$var$load("eiooB"),
    $ed4ef589a938ab7a$var$load("iLyOq"),
    $ed4ef589a938ab7a$var$load("h4Nf7"),
    $ed4ef589a938ab7a$var$load("7f9Fz"),
    $ed4ef589a938ab7a$var$load("8YSo7"),
    $ed4ef589a938ab7a$var$load("lYvov"),
    $ed4ef589a938ab7a$var$load("k8XPW"),
    $ed4ef589a938ab7a$var$load("fWCRm"),
    $ed4ef589a938ab7a$var$load("g9CVe"),
    $ed4ef589a938ab7a$var$load("aeEUI"),
    $ed4ef589a938ab7a$var$load("hRUX7"),
    $ed4ef589a938ab7a$var$load("g4oYs"),
    $ed4ef589a938ab7a$var$load("6wr18"),
    $ed4ef589a938ab7a$var$load("kjZZD"),
    $ed4ef589a938ab7a$var$load("3ySTn"),
    $ed4ef589a938ab7a$var$load("c2rHL"),
    $ed4ef589a938ab7a$var$load("dTsOE"),
    $ed4ef589a938ab7a$var$load("awqCy"),
    $ed4ef589a938ab7a$var$load("kHOMt"),
    $ed4ef589a938ab7a$var$load("hhss7"),
    $ed4ef589a938ab7a$var$load("6kZfp"),
    $ed4ef589a938ab7a$var$load("2UbDA"),
    $ed4ef589a938ab7a$var$load("nbjnv"),
    $ed4ef589a938ab7a$var$load("Wowvf"),
    $ed4ef589a938ab7a$var$load("ffEVr"),
    $ed4ef589a938ab7a$var$load("jlSv2"),
    $ed4ef589a938ab7a$var$load("1UUrt"),
    $ed4ef589a938ab7a$var$load("jSdjl"),
    $ed4ef589a938ab7a$var$load("l2EUC"),
    $ed4ef589a938ab7a$var$load("kWZnd"),
    $ed4ef589a938ab7a$var$load("92LGf"),
    $ed4ef589a938ab7a$var$load("jk2zg"),
    $ed4ef589a938ab7a$var$load("zjNVa"),
    $ed4ef589a938ab7a$var$load("9IeAj"),
    $ed4ef589a938ab7a$var$load("kUbUu"),
    $ed4ef589a938ab7a$var$load("2PePB"),
    $ed4ef589a938ab7a$var$load("1W4KB"),
    $ed4ef589a938ab7a$var$load("lnKog"),
    $ed4ef589a938ab7a$var$load("9ftJe"),
    $ed4ef589a938ab7a$var$load("h3ABO"),
    $ed4ef589a938ab7a$var$load("kC80R"),
    $ed4ef589a938ab7a$var$load("7EorR"),
    $ed4ef589a938ab7a$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("4Mq4C", function(module, exports) {

let $37afdec598b36300$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $37afdec598b36300$var$load("k8XPW"),
    $37afdec598b36300$var$load("fWCRm"),
    $37afdec598b36300$var$load("2YffH"),
    $37afdec598b36300$var$load("2PePB"),
    $37afdec598b36300$var$load("1V9QO"),
    $37afdec598b36300$var$load("j03h9"),
    $37afdec598b36300$var$load("eiooB"),
    $37afdec598b36300$var$load("iLyOq"),
    $37afdec598b36300$var$load("h4Nf7"),
    $37afdec598b36300$var$load("7f9Fz"),
    $37afdec598b36300$var$load("8YSo7"),
    $37afdec598b36300$var$load("lYvov"),
    $37afdec598b36300$var$load("g9CVe"),
    $37afdec598b36300$var$load("aeEUI"),
    $37afdec598b36300$var$load("hRUX7"),
    $37afdec598b36300$var$load("g4oYs"),
    $37afdec598b36300$var$load("6wr18"),
    $37afdec598b36300$var$load("kjZZD"),
    $37afdec598b36300$var$load("3ySTn"),
    $37afdec598b36300$var$load("c2rHL"),
    $37afdec598b36300$var$load("awqCy"),
    $37afdec598b36300$var$load("kHOMt"),
    $37afdec598b36300$var$load("hhss7"),
    $37afdec598b36300$var$load("6kZfp"),
    $37afdec598b36300$var$load("2UbDA"),
    $37afdec598b36300$var$load("nbjnv"),
    $37afdec598b36300$var$load("Wowvf"),
    $37afdec598b36300$var$load("ffEVr"),
    $37afdec598b36300$var$load("jlSv2"),
    $37afdec598b36300$var$load("1UUrt"),
    $37afdec598b36300$var$load("jSdjl"),
    $37afdec598b36300$var$load("l2EUC"),
    $37afdec598b36300$var$load("kWZnd"),
    $37afdec598b36300$var$load("92LGf"),
    $37afdec598b36300$var$load("jk2zg"),
    $37afdec598b36300$var$load("zjNVa"),
    $37afdec598b36300$var$load("9IeAj"),
    $37afdec598b36300$var$load("1W4KB"),
    $37afdec598b36300$var$load("kUbUu"),
    $37afdec598b36300$var$load("9ftJe"),
    $37afdec598b36300$var$load("h3ABO"),
    $37afdec598b36300$var$load("kC80R"),
    $37afdec598b36300$var$load("7EorR"),
    $37afdec598b36300$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("aCH1P", function(module, exports) {

let $7bbed48af7dd5885$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7bbed48af7dd5885$var$load("k8XPW"),
    $7bbed48af7dd5885$var$load("fWCRm"),
    $7bbed48af7dd5885$var$load("2YffH"),
    $7bbed48af7dd5885$var$load("1V9QO"),
    $7bbed48af7dd5885$var$load("j03h9"),
    $7bbed48af7dd5885$var$load("eiooB"),
    $7bbed48af7dd5885$var$load("iLyOq"),
    $7bbed48af7dd5885$var$load("h4Nf7"),
    $7bbed48af7dd5885$var$load("7f9Fz"),
    $7bbed48af7dd5885$var$load("8YSo7"),
    $7bbed48af7dd5885$var$load("lYvov"),
    $7bbed48af7dd5885$var$load("g9CVe"),
    $7bbed48af7dd5885$var$load("aeEUI"),
    $7bbed48af7dd5885$var$load("hRUX7"),
    $7bbed48af7dd5885$var$load("g4oYs"),
    $7bbed48af7dd5885$var$load("6wr18"),
    $7bbed48af7dd5885$var$load("kjZZD"),
    $7bbed48af7dd5885$var$load("3ySTn"),
    $7bbed48af7dd5885$var$load("c2rHL"),
    $7bbed48af7dd5885$var$load("awqCy"),
    $7bbed48af7dd5885$var$load("kHOMt"),
    $7bbed48af7dd5885$var$load("hhss7"),
    $7bbed48af7dd5885$var$load("6kZfp"),
    $7bbed48af7dd5885$var$load("2UbDA"),
    $7bbed48af7dd5885$var$load("nbjnv"),
    $7bbed48af7dd5885$var$load("Wowvf"),
    $7bbed48af7dd5885$var$load("ffEVr"),
    $7bbed48af7dd5885$var$load("jlSv2"),
    $7bbed48af7dd5885$var$load("1UUrt"),
    $7bbed48af7dd5885$var$load("jSdjl"),
    $7bbed48af7dd5885$var$load("l2EUC"),
    $7bbed48af7dd5885$var$load("kWZnd"),
    $7bbed48af7dd5885$var$load("92LGf"),
    $7bbed48af7dd5885$var$load("jk2zg"),
    $7bbed48af7dd5885$var$load("zjNVa"),
    $7bbed48af7dd5885$var$load("9IeAj"),
    $7bbed48af7dd5885$var$load("kUbUu"),
    $7bbed48af7dd5885$var$load("2PePB"),
    $7bbed48af7dd5885$var$load("1W4KB"),
    $7bbed48af7dd5885$var$load("lnKog"),
    $7bbed48af7dd5885$var$load("9ftJe"),
    $7bbed48af7dd5885$var$load("h3ABO"),
    $7bbed48af7dd5885$var$load("kC80R"),
    $7bbed48af7dd5885$var$load("7EorR"),
    $7bbed48af7dd5885$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("a3THr", function(module, exports) {

let $01e3f539c64528e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01e3f539c64528e7$var$load("k8XPW"),
    $01e3f539c64528e7$var$load("fWCRm"),
    $01e3f539c64528e7$var$load("2YffH"),
    $01e3f539c64528e7$var$load("1V9QO"),
    $01e3f539c64528e7$var$load("j03h9"),
    $01e3f539c64528e7$var$load("eiooB"),
    $01e3f539c64528e7$var$load("iLyOq"),
    $01e3f539c64528e7$var$load("h4Nf7"),
    $01e3f539c64528e7$var$load("7f9Fz"),
    $01e3f539c64528e7$var$load("8YSo7"),
    $01e3f539c64528e7$var$load("lYvov"),
    $01e3f539c64528e7$var$load("g9CVe"),
    $01e3f539c64528e7$var$load("aeEUI"),
    $01e3f539c64528e7$var$load("hRUX7"),
    $01e3f539c64528e7$var$load("g4oYs"),
    $01e3f539c64528e7$var$load("6wr18"),
    $01e3f539c64528e7$var$load("kjZZD"),
    $01e3f539c64528e7$var$load("3ySTn"),
    $01e3f539c64528e7$var$load("c2rHL"),
    $01e3f539c64528e7$var$load("awqCy"),
    $01e3f539c64528e7$var$load("kHOMt"),
    $01e3f539c64528e7$var$load("hhss7"),
    $01e3f539c64528e7$var$load("6kZfp"),
    $01e3f539c64528e7$var$load("2UbDA"),
    $01e3f539c64528e7$var$load("nbjnv"),
    $01e3f539c64528e7$var$load("Wowvf"),
    $01e3f539c64528e7$var$load("ffEVr"),
    $01e3f539c64528e7$var$load("jlSv2"),
    $01e3f539c64528e7$var$load("1UUrt"),
    $01e3f539c64528e7$var$load("jSdjl"),
    $01e3f539c64528e7$var$load("l2EUC"),
    $01e3f539c64528e7$var$load("kWZnd"),
    $01e3f539c64528e7$var$load("92LGf"),
    $01e3f539c64528e7$var$load("jk2zg"),
    $01e3f539c64528e7$var$load("zjNVa"),
    $01e3f539c64528e7$var$load("9IeAj"),
    $01e3f539c64528e7$var$load("kUbUu"),
    $01e3f539c64528e7$var$load("2PePB"),
    $01e3f539c64528e7$var$load("1W4KB"),
    $01e3f539c64528e7$var$load("lnKog"),
    $01e3f539c64528e7$var$load("9ftJe"),
    $01e3f539c64528e7$var$load("h3ABO"),
    $01e3f539c64528e7$var$load("kC80R"),
    $01e3f539c64528e7$var$load("7EorR"),
    $01e3f539c64528e7$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bSdpv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("bSdpv", function(module, exports) {

let $8a4f23dbcd20a889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a4f23dbcd20a889$var$load("2PePB"),
    $8a4f23dbcd20a889$var$load("1W4KB"),
    $8a4f23dbcd20a889$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.c4f0c090.js.map
